import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";

import CardLimitsTabsItem from "./CardLimitsTabsItem/CardLimitsTabsItem.js";

import "./CardLimitsTabs.scss";

const CardLimitsTabs = ({
  tabs,
  cardLimitList,
  getSingleCardLimit,
  setOpenForm,
  t
}) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]?.zoneType);
  const [securityLimitsOpen, setSecurityLimitsOpen] = useState(false);

  const securityLimitList = cardLimitList?.filter((item) => item?.typeId === 1);
  const zoneLimitList = cardLimitList?.filter((item) => item?.typeId !== 1);

  const handleChange = (event, value) => {
    setSelectedTab(value);
    setOpenForm(false);
    setSecurityLimitsOpen(false);
  };

  return (
    <div className="ibank__tabs">
      <Box sx={{ width: "100%" }}>
        <TabContext value={selectedTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="tab labels">
              {tabs?.map(({ label, zoneType }, index) => {
                return <Tab value={zoneType} {...{ label }} key={index} />;
              })}
            </TabList>
          </Box>
          <TabPanel value={selectedTab}>
            {zoneLimitList?.map(
              (
                {
                  zoneType,
                  name,
                  limitCodeId,
                  defaultLimit,
                  currencyLimit,
                  limit_rule: limitRule,
                },
                index
              ) => {
                return (
                  zoneType == selectedTab && (
                    <CardLimitsTabsItem
                      key={index}
                      {...{
                        name,
                        defaultLimit,
                        currencyLimit,
                        limitCodeId,
                        limitRule,
                        getSingleCardLimit,
                        setOpenForm,
                        t
                      }}
                    />
                  )
                );
              }
            )}
            {selectedTab === 2 && securityLimitList?.length > 0 && (
              <div className="ibank-card-limits__tabs__item">
                <div
                  className="ibank-card-limits__tabs__item__content position-relative"
                  onClick={() => setSecurityLimitsOpen(!securityLimitsOpen)}
                >
                  <p className="ibank-card-limits__tabs__item__content__header">{t("safetyLimitsTitle")}</p>
                  <p className="ibank-card-limits__tabs__item__content__desc">
                    {t("safetyLimitsFooter")}
                  </p>
                  <div className="ibank-card-limits__tabs__item__content__tab-icon">
                    {securityLimitsOpen ?
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M15 12.5L10 7.5L5 12.5" stroke="#404040" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="#404040" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    }
                  </div>
                </div>
                <div className="ml-4 mt-2">
                  {securityLimitsOpen &&
                    securityLimitList.map(
                      (
                        {
                          name,
                          limitCodeId,
                          // defaultLimit,
                          currencyLimit,
                          limit_rule: limitRule,
                        },
                        index
                      ) => (
                        <CardLimitsTabsItem
                          key={limitCodeId || index}
                          {...{
                            name,
                            // defaultLimit,
                            currencyLimit,
                            limitCodeId,
                            limitRule,
                            getSingleCardLimit,
                            setOpenForm,
                            t,
                          }}
                        />
                      )
                    )}
                </div>
              </div>
            )}
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
};

export default CardLimitsTabs;
